import { useNavigate } from "react-router-dom";
import ICONS from "../../../assets/Icons";

const PageNotFound = () => {
  const navigate = useNavigate();

  const checkToken = window.sessionStorage.getItem("q2p_token");

  const goToHomePage = () => {
    if (checkToken) {
      navigate("/home");
    } else {
      navigate("/");
    }
  };
  return (
    <div className="flex flex-col items-center justify-center h-screen overflow-hidden mt-margin-md">
      <img
        src={ICONS?.PAGE_NOT_FOUND}
        alt="Centered"
        className="h-96 max-w-full max-h-full"
      />
      <div className="text-center">
        <h4 className="text-4xl text-text-primary mb-margin-sm">
          Page not found
        </h4>
        <p className="text-lg text-text-primary">
          Sorry, the page you are looking for does not exist.
        </p>
        <div className="pt-padding-md mt-margin-lg">
          <button
            className="bg-text-primary text-black p-padding-md rounded-4xl font-semibold hover:bg-[#DBDBDB]"
            onClick={goToHomePage}
          >
            GO TO {checkToken ? "HOME DASHBOARD" : "HOME"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
